import { useApiFetcherSWR } from "hooks/SwrCustom";


export const API_ENDPOINT = {
  UPDATE_DOCUMENT_DATE: {
    url: "gebruiker/update-date",
    method: "post",
  },

  UPDATE_LOCK_STATE: {
    url: "gebruiker/update-lock",
    method: "post",
  },

  MOVE_DOCUMENT: {
    url: "gebruiker/move-document",
    method: "post",
  },

  DELETE_DOCUMENT: {
    url: "gebruiker/deleteDocument",
    method: "get",
  },

  DELETE_VERVANGER_DOC: {
    url: "gebruiker/deleteUserDocument",
    method: "post",
  },
};

export const useUpdateDocumentDate = () =>
  useApiFetcherSWR(API_ENDPOINT.UPDATE_DOCUMENT_DATE);

export const useUpdateLockState = () =>
  useApiFetcherSWR(API_ENDPOINT.UPDATE_LOCK_STATE);

export const useMoveDocument = () =>
  useApiFetcherSWR(API_ENDPOINT.MOVE_DOCUMENT);

export const useDeleteDocument = (payload) =>
  useApiFetcherSWR(
    payload?.id &&
      payload?.iDocTypeId &&
      payload?.iAdminId &&
      payload?.iCommunityId
      ? {
        ...API_ENDPOINT.DELETE_DOCUMENT,
        url: `${API_ENDPOINT.DELETE_DOCUMENT.url}/${payload.id}`,
        params: {
          iDocTypeId: payload.iDocTypeId,
          iAdminId: payload.iAdminId,
          iCommunityId: payload.iCommunityId,
          property: payload.property,
        },
      }
      : null
  );

export const useDeleteVervangerDoc = () =>
  useApiFetcherSWR(API_ENDPOINT.DELETE_VERVANGER_DOC);